import { useNavigate, useLocation } from 'react-router-dom';

// Centralized client-side navigation for the whole site.
// - Route paths ("/insights", "/") navigate without a full reload and reset scroll.
// - Section links ("#founder-story" or "/#founder-story") smooth-scroll on the
//   homepage, and route to the homepage first when triggered from a sub-page.
// Returns goTo(href, onNavigate?) where onNavigate runs before navigation
// (e.g. to close a mobile menu).
export const useSmartNav = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (href, onNavigate) => {
    if (onNavigate) onNavigate();

    const hashMatch = href.match(/^\/?#(.+)$/);
    if (hashMatch) {
      const id = hashMatch[1];
      const scrollToId = () => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
      if (location.pathname !== '/') {
        navigate('/');
        setTimeout(scrollToId, 300);
      } else {
        scrollToId();
      }
      return;
    }

    navigate(href);
    window.scrollTo(0, 0);
  };
};

export default useSmartNav;
